import { initializeApp } from "firebase/app";

import {
  getAuth,
  GoogleAuthProvider,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD1YJq9Q3oTg5ko9bQwEt3kWve52ctJ4cA",
  authDomain: "nukkad-edc40.firebaseapp.com",
  projectId: "nukkad-edc40",
  storageBucket: "nukkad-edc40.firebasestorage.app",
  messagingSenderId: "650888533807",
  appId: "1:650888533807:web:8ab029449a36c909dbb3da"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const provider = new GoogleAuthProvider();